module.exports = __webpack_public_path__ + "ed8df5ba4eb7a1af13fb16905c2fa944.png";